import { graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { ContentBlocks } from '../components/articleContent'
import Enquiry from '../components/enquiry'
import Layout from '../components/layout'
import Link from '../components/link'
import SEO from '../components/seo'
import Spacer from '../components/spacer'

export default function BlogPost({ data: { page, article, perspectiv, next } }) {
	return (
		<Layout footer='is-light' className={' bg--light is-dark '}>
			<SEO title={article?.seoTitle || article?.title} description={article?.seoDescription || null} datePublished={article?.meta?.createdAt} dateModified={article?.meta?.updatedAt} isArticle={true} image={article?.image?.gatsbyImageData?.images?.fallback?.src} />

			<div className='p40 m-p20 content bg-white bg--light dark-grey'>
				<div className='bb1 mb20'>
					<Spacer />
					<h1 className='h2 max-1000 ma text-center'>{article?.title}</h1>
					<Spacer />
					<div className='flex gap-30 align-center mb20'>
						<div className='flex gap-3'>
							{article?.category?.flat()?.map(category => (
								<span key={category?.id} className='tag white'>
									{category?.title}
								</span>
							))}
						</div>
						<div>
							<p className='small m0 text-grey'>{article?.meta?.publishedAt}</p>
						</div>
					</div>
				</div>
				<Link to='/perspective' className='text-grey link small'>
					Back to news
				</Link>
				<div className='article-content-grid mt40'>
					<div className='pos-rel'>
						<div className='pos-sticky top-100 max-400 m-mwa black'>
							<ShareButtons />
						</div>
					</div>

					<div className='flex flex-col gap-60'>
						<p className='h2 m0 balance'>{article?.shortDescription}</p>
						<div className='overflow pos-rel ratio-3-2'>{article?.featuredVideo ? <iframe frameBorder='0' referrerpolicy="strict-origin-when-cross-origin" width='100%' height='100%' title='Featured Video' allowFullScreen allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' src={`https://www.youtube-nocookie.com/embed/${article?.featuredVideo?.providerUid}?rel=0&modestbranding=1&playsinline=1`}></iframe> : <GatsbyImage image={article?.image?.gatsbyImageData} alt='' className='bg-image' />}</div>
						<ContentBlocks blocks={article?.content} />
					</div>
					<div className='pos-rel'>
						<div className='sticky max-450 m-mwa m-m0 mla flex flex-col'>
							<Spacer />
							<Link to={`/perspective/${next?.slug}`} className='block link ratio-3-2  pos-rel overflow'>
								<GatsbyImage image={next?.image?.gatsbyImageData} alt='' className='bg-image image--zoom' />
							</Link>
							<Link to={`/perspective/${next?.slug}`} className='block small link black ul-link mla more-padding uppercase circular mt20 w-fit'>
								Next Perspectiv
							</Link>
						</div>
					</div>
				</div>
				<Spacer />
				<Spacer />
				<div className='bb1 light' />
				<Spacer />
			</div>
			<div className='bg-white dark-grey'>
				<Enquiry light dark title={page?.contactTitle} titleTwo={page?.contactTitleTwo} subtitle={page?.contactSubtitle} subtitleTwo={page?.contactSubtitleTwo} />
				<Spacer />
				<Instagram title={perspectiv?.instagramTitle} handle={perspectiv?.instagramHandle} gallery={perspectiv?.instagramImages} />
				<Spacer />
				<div className='p40 pb0'>
					<div className='bb1 light' />
				</div>
			</div>
		</Layout>
	)
}

const ShareButtons = () => {
	const copyToClipboard = () => {
		const url = window.location.href
		navigator.clipboard.writeText(url).then(() => {
			alert('URL copied to clipboard!')
		})
	}

	const shareToFacebook = () => {
		const url = window.location.href
		const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
		window.open(facebookShareUrl, '_blank')
	}

	const shareToLinkedIn = () => {
		const url = window.location.href
		const linkedInShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`
		window.open(linkedInShareUrl, '_blank')
	}

	const shareToTwitter = () => {
		const url = window.location.href
		const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`
		window.open(twitterShareUrl, '_blank')
	}

	const shareToEmail = () => {
		const url = window.location.href
		const emailShareUrl = `mailto:?subject=Check this article out&body=${encodeURIComponent(url)}`
		window.open(emailShareUrl, '_self')
	}

	return (
		<>
			<p className='circular normal m0 mb20'>Share</p>
			<div className='flex flex-wrap max-200 gap-3 m-mb40'>
				<button className='button tag white' onClick={copyToClipboard}>
					Link
				</button>
				<button className='button tag white' onClick={shareToEmail}>
					Email
				</button>
				<button className='button tag white' onClick={shareToFacebook}>
					Facebook
				</button>
				<button className='button tag white' onClick={shareToLinkedIn}>
					LinkedIn
				</button>
				<button className='button tag white' onClick={shareToTwitter}>
					Twitter
				</button>
			</div>
		</>
	)
}

export const Instagram = ({ title, handle, gallery }) => {
	return (
		<div className='p40'>
			<div className='bt1 light pt20 flex gap-20'>
				<p className='signifier'>{title}</p>
				<a target='_blank' rel='noreferrer' href={'https://www.instagram.com/' + handle} className='signifier link mla'>
					@{handle}
				</a>
			</div>
			<Spacer />
			<div className='grid grid-4-c gap-80'>
				{gallery?.map((image, index) => {
					return (
						<a target='_blank' rel='noreferrer' href={'https://www.instagram.com/' + handle}>
							<div className='ratio-1-2 pos-rel overflow'>
								<GatsbyImage image={image?.gatsbyImageData} alt='' className='bg-image image--zoom' />
							</div>
						</a>
					)
				})}
			</div>
		</div>
	)
}

export const query = graphql`
	query BlogPostQuery($id: String!) {
		page: datoCmsHomepage {
			ctaTitle
			ctaSubtitle
			ctaImage {
				gatsbyImageData
			}

			contactTitle
			contactSubtitle
			contactTitleTwo
			contactSubtitleTwo
		}
		perspectiv: datoCmsMediaPage {
			instagramTitle
			instagramHandle
			instagramImages {
				gatsbyImageData
			}
		}
		article: datoCmsArticle(id: { eq: $id }) {
			title
			slug
			shortDescription
			seoTitle
			seoDescription
			readTime
			id
			externalLink
			content {
				... on DatoCmsContent {
					id
					content
				}
				... on DatoCmsQuote {
					id
					content
				}
				... on DatoCmsImage {
					id
					image {
						gatsbyImageData
					}
				}
				... on DatoCmsYoutubeVideo {
					id
					video {
						providerUid
					}
				}
				... on DatoCmsSubheading {
					id
					subheading
				}
				... on DatoCmsSpacer {
					id
				}
			}
			image {
				gatsbyImageData
			}
			featuredVideo {
				providerUid
			}
			meta {
				publishedAt(formatString: "MM/DD/YY")
			createdAt
			updatedAt
			}
			category {
				id
				title
			}
		}
		next: datoCmsArticle(id: { ne: $id }) {
			slug
			image {
				gatsbyImageData
			}
		}
	}
`
